import React from 'react';
import Login from './LoginScreen';

function LoginContainer(){
    return(
        <Login />
    )
}
export default LoginContainer;